<script>
import e4parent from "@/components/charts/e4parent";
export default {
  extends: e4parent,
  props: {
    unit: Boolean,
    parameter: String,
  },
  methods: {
    /* setOption() {
      this.isEmpty = true;
      this.$nextTick(() => {
        this.render(this.getMockData());
      });
    }, */
    getFormatExParams() {
      return {};
    },
    getMockData() {
      return {
        code: 200,
        datatype: "map",
        msg: null,
        datasize: 1,
        data: {
          data: [
            {
              name: "专用设备制造业",
              value: "9.92",
            },
            {
              name: "电气机械和器材制造业",
              value: "9.09",
            },
            {
              name: "食品制造业",
              value: "6.61",
            },
            {
              name: "计算机、通信和其他电子设备制造业",
              value: "6.61",
            },
            {
              name: "软件和信息技术服务业",
              value: "5.79",
            },
            {
              name: "通用设备制造业",
              value: "4.96",
            },
            {
              name: "医药制造业",
              value: "4.96",
            },
            {
              name: "生态保护和环境治理业",
              value: "4.13",
            },
          ],
          legend: [],
          x: [],
          y: [
            "专用设备制造业",
            "电气机械和器材制造业",
            "食品制造业",
            "计算机、通信和其他电子设备制造业",
            "软件和信息技术服务业",
            "通用设备制造业",
            "医药制造业",
            "生态保护和环境治理业",
          ],
          page: {
            totalPage: 5,
            pageSize: 8,
            totalCount: 40,
            currentPage: 1,
          },
        },
        timestamp: 1638323333529,
      };
    },
    getEchartsOptions(data) {
      data = data.data;
      let yData = data.y.reverse();
      let currData = data.data.reverse();
      let colorData = this.colorData;
      let unit = this.unit;
      let option = {
        grid: [
          {
            x: "26%",
            y: "0",
            width: "60%",
            height: "100%",
          },
        ],
        tooltip: {
          confine: true,
          formatter: function (data) {
            let name = data.name;
            let value = data.value;
            let uit = "%";
            return name + "( " + value + uit + ")";
          },
        },
        color: colorData,
        xAxis: [
          {
            show: false,
            name: "数量",
            nameTextStyle: {
              color: "#333333",
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                color: "#f0f0f0",
              },
            },
            axisLabel: {
              color: this.chartsLabelColor || "#333333",

              fontSize: 14,
              formatter: function (data) {
                let uit = "%";
                unit && (uit = "");
                return data + uit;
              },
            },
          },
        ],
        yAxis: [
          {
            gridIndex: 0,
            interval: 0,
            data: yData,
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#f0f0f0",
              },
            },
            axisLabel: {
              margin: 15,
              interval: 0,
              // borderWidth: 10,
              // borderColor: "#ffffff",
              color: this.chartsLabelColor || "#333333",
              fontSize: 14,
              formatter: function (data) {
                let len = data.length;
                let num = 6;
                return len > num ? data.substring(0, num) + "..." : data;
              },
            },
          },
        ],
        series: [
          {
            type: "bar",
            xAxisIndex: 0,
            yAxisIndex: 0,
            barWidth: 15,
            label: {
              normal: {
                show: true,
                position: "right",
                textStyle: {
                  color: this.chartsLabelColor || "#333333",
                },
                formatter: function (data) {
                  let value = data.value;
                  let uit = "%";
                  unit && (uit = "");
                  return value + uit;
                },
              },
            },
            data: currData,
          },
        ],
      };
      return option;
    },
  },
};
</script>